export default {"src":"/_next/static/media/comments-active-icon.d3021652.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};